import React, { createContext, useContext, useEffect, useState } from 'react';
import { api, setToken, getToken } from './api.js';

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!getToken()) { setReady(true); return; }
    api.me().then(d => setUser(d.user)).catch(() => setToken(null)).finally(() => setReady(true));
  }, []);

  const login = async (payload) => {
    const r = await api.login(payload);
    setToken(r.token);
    setUser(r.user);
    return r.user;
  };

  const logout = () => { setToken(null); setUser(null); };

  return <AuthCtx.Provider value={{ user, ready, login, logout, setUser }}>{children}</AuthCtx.Provider>;
}
